// removed by extract-text-webpack-plugin
module.exports = {"field":"_1qch8","hide":"_3GsZk"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/Account/children/AccountProfile/components/AccountProfileVerify/components/ChangeSchoolForm/ChangeSchoolForm.scss
// module id = 868
// module chunks = 34